import { AddressProps, PropertyCommonsProps, SimpleOwnerProps } from '@/custom-types';
import { CreatePropertyInput, CreateUnityInput, PropertyTypeOption } from '@/graphql/generated';
import { createContext } from 'react';

export type CreatePropertyContextActionsProps = {
  setAddress: (address: AddressProps) => void;
  setPropertyType: (propertyType: PropertyTypeOption) => void;
  setName: (name: string) => void;
  setOwner: (owner: SimpleOwnerProps) => void;
  setUnities: (unities: CreateUnityInput[]) => void;
  setCommons: (commons: PropertyCommonsProps) => void;
  setPictures: (pictures: File[]) => void;
  setVideos: (videos: File[]) => void;
  state: CreatePropertyInput;
  setButtonDisabled: () => void;
  setButtonEnabled: () => void;
  buttonState: boolean;
  ownerData: SimpleOwnerProps | undefined;
  pictures: File[];
  videos: File[];
}

export const CreatePropertyContext = createContext<CreatePropertyContextActionsProps | null>(null)
